import LottoToken from "../../client/src/contracts/Token.json";
import { derived } from 'svelte/store'
import { web3, chainId } from 'svelte-web3'

const LottoContractStore = derived([web3, chainId], ([$web3, $chainId]) => {
  if ($chainId && $web3.eth) {
    let address
    try {
      address = LottoToken.networks[$chainId].address
      console.log(address)
   }
    catch (e) { 
      window.alert("LTT not on your connected Network. Connect to Rinkeby")
   }
    return new $web3.eth.Contract(LottoToken.abi, address, {})
  }
  return null
})
export default LottoContractStore
